import React from 'react'
import { Image, View } from 'react-native';

import { colors } from '../../shared/const'
import { CaptionNormalDark, CaptionBoldDark } from './TextStyles';
import styles from '../../shared/styles';
import { RoundedIcon } from '.';

import starIcon from '../assets/icon/star_white.png'
import shap_left from '../assets/icon/arrow_shape_left.png'
import shap_right from '../assets/icon/arrow_shape_right.png'
import CheckIcon from '../assets/icon/check_white.png'
import progress_ic from '../assets/ic_120/progress_ic.png'

export const RateAvatar = ({ rate, title }) => {
    let backgroundColor = colors.indigo;
    if (rate === 100){
        backgroundColor = colors.yellow;
    }
    if (rate === 0) return <RateLockAvatar title={title}/>
    return(
        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
            <RoundedIcon
                color={backgroundColor}
                height={60}
                icon={(<Image style={{ height: '60%', width: '60%' }} source={starIcon} resizeMode="contain"/>)}
            />
            <View style={{ flexDirection: 'row', marginTop: -6 }}>
                <Image
                    source={shap_left}
                    style={{ height: 16, width: 22, marginRight: -8, marginTop: 3.5 }}
                />
                <View style={{ width: 50, borderWidth: 1, borderColor: '#fff', justifyContent: 'center', alignItems: 'center', borderRadius: 4, backgroundColor: '#FFD600', zIndex: 999, height: 18 }}>
                    <CaptionNormalDark title={rate + '%'}/>
                </View>
                <Image
                    source={shap_right}
                    style={{ height: 16, width: 22, marginLeft: -8, marginTop: 3.5 }}
                />
            </View>
            <CaptionBoldDark title={title}/>
        </View>
    )
}

export const RateLockAvatar = ({ title }) => {
    return (
        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
            <RoundedIcon
                color='#C3BFCC'
                height={60}
                icon={(<Image style={{ height: '60%', width: '60%' }} source={starIcon} resizeMode="contain"/>)}
            />
            <View style={{ flexDirection: 'row', marginTop: -6 }}>
                <Image
                    source={shap_left}
                    style={{ height: 16, width: 22, marginRight: -8, marginTop: 3.5 }}
                />
                <View style={{ width: 50, borderWidth: 1, borderColor: '#fff', justifyContent: 'center', alignItems: 'center', borderRadius: 4, backgroundColor: '#FFD600', zIndex: 999, height: 18 }}>
                    <CaptionNormalDark title="0%"/>
                </View>
                <Image
                    source={shap_right}
                    style={{ height: 16, width: 22, marginLeft: -8, marginTop: 3.5 }}
                />
            </View>
            <CaptionBoldDark title={title} />
        </View>
    )
}

export const ProfileAvatar = ({ src, size }) => {
    if(src.uri){
        if(window.Base64Img[src.uri]) src.uri = window.Base64Img[src.uri];
    }
    return (
        <View style={styles.profileAvatar}>
            {
                src.uri !== "" ? 
                    <Image source={src} style={{ height: size || '90%', width: size || '90%' }} resizeMode="contain"/>
                : null
            }
        </View>
    );
}

export const SuccessAvatar = ({ size }) => {
    return (
        <View style={{ height: size, width: size, backgroundColor: '#00c221', borderRadius: size, overflow: 'hidden', justifyContent: 'center', alignItems: 'center' }}>
            <Image source={CheckIcon} style={{ height: size * 0.45, width: size * 0.45 }} resizeMode="contain"/>
        </View>
    )
}

export const DailyprogressAvatar = ({ size }) => {
    return (
        <Image source={progress_ic} style={{ height: size, width: size}} resizeMode="contain"/>
    )
}